import React from 'react';
import PropTypes from 'prop-types';

import './UserCardInfo.scss';
import creditCardIcon from './assets/CardIcon';
import LinkButton from '../../_atomic/LinkButton/LinkButton';

const propTypes = {
  lastFour: PropTypes.string.isRequired,
  clickChangeHandler: PropTypes.func.isRequired,
  isAdmin: PropTypes.bool,
};

const defaultProps = {
  isAdmin: false,
};

const UserCardInfo = ({ lastFour, clickChangeHandler, isAdmin }) =>
  (
    <div className="user-card-info-wrapper">

      <div className="user-card-info">
        <div className="img-wrapper"> {creditCardIcon}</div>
        <span className="card-number">**** {lastFour}</span>
      </div>
      {!isAdmin &&
      <div className="links-wrapper">
        <LinkButton text="Change" clickHandler={clickChangeHandler} />
      </div>
      }
    </div>
  );
UserCardInfo.propTypes = propTypes;
UserCardInfo.defaultProps = defaultProps;

export default UserCardInfo;



// WEBPACK FOOTER //
// ./src/components/_molecules/UserCardInfo/UserCardInfo.js